/**
 * 创建、编辑、复制弹框
 */
import React, { useState, useEffect, Fragment } from 'react';
import styles from './index.module.scss';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import http from '@/assets/api/http'
import { message, Modal, Radio, Tag } from 'antd';
import { XInput, XDatePicker, XInputNum } from '@/components/xqxc_ui';
import model from '@/reducers/system/operatingrule/model';
import { regFenToYuan, regYuanToFen } from '@/util/money';
import moment from 'moment';

const CECModal = ({
    closeMode,
    data: {
        id = '',
        title = '',
        url = '',
        tip = '',
        type = ''
    } = {},
    getTopUpRuleInfo,
    topUpRuleInfo = {}
}) => {

    const [loading, setLoading] = useState(false);
    const [rulesName, setRulesName] = useState(null);
    const [dateType, setDateType] = useState(1);
    const [startDate, setStartDate] = useState(undefined);
    const [endDate, setEndDate] = useState(undefined);
    const [recharge, setRecharge] = useState(null);
    const [giveAway, setGiveAway] = useState(null);
    const [tagList, setTagList] = useState([
        { id: 10, title: '10天', color: 'magenta', isCheck: false },
        { id: 30, title: '30天', color: 'red', isCheck: false },
        { id: 60, title: '60天', color: 'volcano', isCheck: false },
        { id: 365, title: '365天', color: 'green', isCheck: false },
        { id: -1, title: '永久', color: 'cyan', isCheck: false }
    ]);
    const [days, setDays] = useState();

    useEffect(() => {
        if (id) {
            getTopUpRuleInfo({ id });
        }
    }, []);

    useEffect(() => {
        if (id) {
            const { title, startTime, endTime, rechargeAmount, giftAmount, days } = topUpRuleInfo;
            if (days) {
                const list = tagList.map(item => {
                    if (item.id == (type ? 365 : days)) {
                        return { ...item, isCheck: true };
                    }
                    return { ...item, isCheck: false };
                });
                setDateType(1);
                setDays(type ? 365 : days);
                setTagList(list);
            } else {
                const list = tagList.map(item => {
                    if (item.id == 365) {
                        return { ...item, isCheck: true };
                    }
                    return { ...item, isCheck: false };
                });
                setTagList(list);
                setDateType(1);
                setDateType(type ? 1 : 2);
                setStartDate(type ? undefined : startTime);
                setEndDate(type ? undefined : endTime);
            }
            setRulesName(title);
            setRecharge(regFenToYuan(rechargeAmount));
            setGiveAway(regFenToYuan(giftAmount));
        }
    }, [topUpRuleInfo]);

    const tagStyle = {
        marginLeft: '20px',
        cursor: 'pointer'
    };

    const tagCilck = (id) => {
        const list = tagList.map(item => {
            if (item.id == id) {
                return { ...item, isCheck: true };
            }
            return { ...item, isCheck: false };
        });
        setDays(id);
        setTagList(list);
    };

    const saveRules = () => {
        if (dateType == 1 && !days) {
            message.warn('请选择天数');
            return;
        }
        if (dateType == 2 && (!startDate || !endDate)) {
            message.warn('请选择日期');
            return;
        }
        if (!recharge) {
            message.warn('请输入充值金额');
            return;
        }
        setLoading(true);
        http(url, {
            id: (id && !type) ? id : undefined,
            title: rulesName,
            rechargeAmount: regYuanToFen(recharge),
            giftAmount: regYuanToFen(giveAway),
            startTime: dateType == 1 ? undefined : moment(startDate).format('YYYY-MM-DD'),
            endTime: dateType == 1 ? undefined : moment(endDate).format('YYYY-MM-DD'),
            days: dateType == 1 ? days : undefined
        }, 'POST')
            .then(res => {
                message.success(tip);
                setLoading(false);
                closeMode(true);
            })
            .catch(err => {
                message.error(err.message);
                setLoading(false);
            })
    };

    return (
        <Modal
            width={500}
            centered
            title={title}
            visible={true}
            confirmLoading={loading}
            onOk={saveRules}
            onCancel={() => closeMode()}
            destroyOnClose={true}
            keyboard={true}
            maskClosable={false}
            cancelText='取消'
            okText='确认'
        >
            <div className={styles.container}>
                <XInput
                    placeholder='请输入规则名称'
                    style={{ marginBottom: '20px' }}
                    inputStyle={{ width: '300px' }}
                    label='规则名称：'
                    value={rulesName}
                    bindThis={setRulesName}
                    bindName='rulesName'
                    isRequired={true}
                />
                <div className={styles.component}>
                    <div className={styles.star}>*</div>
                    <div className={styles.label}>日期类型：</div>
                    <div className={styles.inputbox}>
                        <Radio.Group value={dateType} onChange={e => setDateType(e.target.value)}>
                            <Radio key={1} value={1}>天数</Radio>
                            <Radio key={2} value={2}>自定义</Radio>
                        </Radio.Group>
                    </div>
                </div>
                {
                    dateType == 2 ?
                        <div className={styles.conditions}>
                            <XDatePicker
                                label='起止日期：'
                                placeholder='请选择起始日期'
                                value={startDate}
                                bindThis={setStartDate}
                                bindName='startDate'
                                showTime={false}
                                disabledDate={current => {
                                    return current && current < moment().endOf('day').subtract(1, 'days');
                                }}
                            />
                            <XDatePicker
                                placeholder='请选择结束日期'
                                value={endDate}
                                bindThis={setEndDate}
                                bindName='endDate'
                                showTime={false}
                                disabledDate={current => {
                                    return current && current < moment().endOf('day').subtract(1, 'days');
                                }}
                            />
                        </div> :
                        <div className={styles.conditions}>
                            {
                                tagList.map(item => {
                                    return <Tag
                                        key={item.id}
                                        style={tagStyle}
                                        color={item.isCheck ? '#f00' : item.color}
                                        onClick={() => tagCilck(item.id)}
                                    >{item.title}</Tag>
                                })
                            }
                        </div>
                }
                <XInputNum
                    placeholder='请输入充值金额'
                    label='充值金额：'
                    style={{ marginBottom: '20px' }}
                    min={0.00}
                    max={99999.99}
                    precision={2}
                    isRequired={true}
                    value={recharge}
                    bindName='recharge'
                    bindThis={setRecharge}
                />
                <XInputNum
                    placeholder='请输入赠送金额'
                    label='赠送金额：'
                    min={0.00}
                    max={99999.99}
                    precision={2}
                    value={giveAway}
                    bindName='giveAway'
                    bindThis={setGiveAway}
                />
            </div>
        </Modal>
    );

};

CECModal.propTypes = {
    closeMode: PropTypes.func, // 关闭弹框的回调函数
    data: PropTypes.object,
    getTopUpRuleInfo: PropTypes.func,
    topUpRuleInfo: PropTypes.object,
};

export default connect(state => ({
    topUpRuleInfo: state.operatingrule.topUpRuleInfo,
}), model.actions)(CECModal);